export default __webpack_public_path__ + "static/media/40_2_0.6bd9c6b1.png";